import React from 'react';
import { useEsito, useInfoEsito } from 'features/sport/hooks';

import { ScommesseLeafItemProps } from 'components/scommesseTipo/components/cells/types';
import { useTranslation } from 'hooks/useLingUI';

export const QuotaCell = ({ itemKey }: ScommesseLeafItemProps) => {
  const { t } = useTranslation();
  const esito = useEsito(itemKey);
  const { infoEsitoKey } = esito ?? {};
  const infoEsito = useInfoEsito(infoEsitoKey);

  // N.B. description attributes should come from infoEsito only, but temporarly we allow esito source for backward compatibility
  const { descrizione, descrizioneTrKey } = { ...infoEsito, ...esito };

  return (
    <React.Fragment key={`QuotaCell-${descrizioneTrKey}-${descrizione}`}>
      {t(descrizioneTrKey, descrizione)}
    </React.Fragment>
  );
};